import * as agents from './agents'

import * as groups from './groups'

import * as form from './form'

import * as headers from './headers'

import * as iframe from './iframe'

import * as knowledgeBase from './knowledge-base'

import * as main from './main'

import * as persons from './persons'

import * as room from './room'

import * as session from './session'

import * as settings from './settings'

import * as socket from './socket'

import * as ticket from './ticket'

import * as customers from './customers'

import * as flux from './flux'

import * as widget from './widget'

import * as upload from './upload'

import * as company from './company'

export default {
  socket,
  iframe,
  settings,
  agents,
  groups,
  headers,
  ticket,
  form,
  main,
  session,
  room,
  persons,
  knowledgeBase,
  customers,
  flux,
  widget,
  upload,
  company
}
